import React, { useState, useEffect, useContext, ChangeEvent } from 'react'
import ApiService from '../../../../services/ApiService'
import { validateToken } from '../../../../utils/tokenValidation'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  ProgressBarDiv,
  ProgressBarCircle,
  ProgressBarLine,
  InputRowDiv,
  InputDiv,
  InputLabel,
  Input,
  SwitchesDiv,
  SwitchDiv,
  SwitchLabel,
  SwitchBox,
  SwitchInput,
  SwitchSlider,
  FilesDiv,
  FileBlockDiv,
  FileHeaderText,
  FileInputDiv,
  FileInputLabel,
  FileInput,
  FilesInfoDiv,
  FileInfoDiv,
  FileInfoImg,
  FileMiddleDiv,
  FileUpperMiddleDiv,
  FileName,
  FilePercentage,
  FileInfoCancelImg,
  ProgressContainer,
  ProgressFill,
  FileFirstText,
  FileSecondText,
  ButtonsDiv,
  WarningDiv,
  WarningText,
  PreviousButtonDiv,
  PreviousButtonImage,
  PreviousButtonText,
  NextButtonDiv,
  NextButtonImage,
  NextButtonText,
} from './style'
import ModalContext from '../../../../contexts/ModalContext'
import StockContext from '../../../../contexts/StockContext'
import cross from '../../../../assets/addStockModal/cross.svg'
import arrowLeft from '../../../../assets/addStockModal/pages/arrow-left.svg'
import fileIcon from '../../../../assets/addStockModal/pages/file.svg'
import cancelIcon from '../../../../assets/addStockModal/pages/cancel.svg'
import diskIcon from '../../../../assets/addStockModal/pages/disk.svg'
import StockDropdown from '../StockDropdown'
import {
  FieldsToHeaders,
  fieldsToHeaders,
  StockInterface,
} from '../../../../pages/ClientPanel/Stock/StockTable/utils'
import UserContext from '../../../../contexts/UserContext'
import { Info } from 'lucide-react'
import LoadingComponent from '../../../../components/LoadingComponent'
import ConfirmationModal from '../../../../components/ModalConfirmation'

export interface ProgressBar {
  completion: number
}

const LoadingButtonContent: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <span
        style={{
          fontSize: 'inherit',
          fontWeight: 'inherit',
        }}
      >
        Aguarde...
      </span>
    </div>
  )
}

const ThirdCustomAddPage: React.FC = () => {
  console.log('🚀 [THIRDPAGE] Componente ThirdCustomAddPage carregado');

  const { setModalActive, setModalSection, itIsUpdate } =
    useContext(ModalContext)
  const { stock, setStock, setRefresh } = useContext(StockContext)
  const { token } = useContext(UserContext)

  console.log('📋 [THIRDPAGE] Estado inicial:', {
    isUpdate: itIsUpdate,
    hasToken: !!token,
    stockId: stock.id,
    stockCode: stock.code,
    stockFieldsCount: Object.keys(stock).length,
    filledFields: Object.keys(stock).filter(key => stock[key as keyof StockInterface]).length
  });

  const [activeMenu, setActiveMenu] = useState(0)
  const [updateInOmie, setUpdateInOmie] = useState<boolean>(false)
  const [calculateLength, setCalculateLength] = useState<boolean>(false)
  const [calculateWeight, setCalculateWeight] = useState<boolean>(false)
  const [invoiceFiles, setInvoiceFiles] = useState<File[]>(stock.invoice || [])
  const [certificateFiles, setCertificateFiles] = useState<File[]>(
    stock.certificates || [],
  )
  const [warningMessage, setWarningMessage] = useState<string>('')
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [isClosing, setIsClosing] = useState<boolean>(false)

  const initialInvPercentage = new Array(stock.invoice?.length || 0).fill(100)
  const initialCertPercentage = new Array(stock.certificates?.length || 0).fill(
    100,
  )

  const [invPercentage, setInvPercentage] =
    useState<number[]>(initialInvPercentage)
  const [certPercentage, setCertPercentage] = useState<number[]>(
    initialCertPercentage,
  )

  useEffect(() => {
    setWarningMessage('')
  }, [stock, updateInOmie, calculateLength, calculateWeight])

  function getNewName(name: string): string {
    const stlCharacter = parseInt(name.charAt(name.length - 2))
    const last4Characters = ` (${stlCharacter})`
    if (!isNaN(stlCharacter) && name.slice(-4) === last4Characters) {
      const nameStart = name.slice(0, name.length - 2)
      const newName = nameStart + [stlCharacter + 1] + ')'
      return newName
    } else {
      const newName = name + ' (1)'
      return newName
    }
  }

  const handleUploadInvoice = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || [])
    for (let i = 0; i < files.length; i++) {
      for (let j = 0; j < invoiceFiles.length; j++) {
        if (files[i].name === invoiceFiles[j].name) {
          const blob = files[i]
          const newFile = new File([blob], getNewName(files[i].name), {
            type: blob.type,
          })
          files.splice(i, 1, newFile)
        }
      }
    }
    setInvoiceFiles((prevInvoiceFiles) => [...prevInvoiceFiles, ...files])
    setStock((prevStock) => ({
      ...prevStock,
      invoice: [...(prevStock.invoice || []), ...files],
    }))
    const progressArray = Array(files.length).fill(0)
    for (let k = 0; k < files.length; k++) {
      progressArray[k] = 0
    }
  }

  const handleUploadCertificates = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || [])
    for (let i = 0; i < files.length; i++) {
      for (let j = 0; j < certificateFiles.length; j++) {
        if (files[i].name === certificateFiles[j].name) {
          const blob = files[i]
          const newFile = new File([blob], getNewName(files[i].name), {
            type: blob.type,
          })
          files.splice(i, 1, newFile)
        }
      }
    }
    setCertificateFiles((prevCertificateFiles) => [
      ...prevCertificateFiles,
      ...files,
    ])
    setStock((prevStock) => ({
      ...prevStock,
      certificates: [...(prevStock.certificates || []), ...files],
    }))
    const progressArray = Array(files.length).fill(0)
    for (let k = 0; k < files.length; k++) {
      progressArray[k] = 0
    }
  }

  const ProgressHandler = (
    e: ProgressEvent,
    index: number,
    progressArray: any[],
    type: string,
  ) => {
    const percent = (e.loaded / e.total) * 100
    progressArray[index] = percent.toFixed(0)
    if (type === 'inv') {
      const newPercentage = [...invPercentage, ...progressArray]
      setInvPercentage(newPercentage)
    } else {
      const newPercentage = [...certPercentage, ...progressArray]
      setCertPercentage(newPercentage)
    }
  }

  const handleInvDelete = (name: string, index: number) => {
    const newArray = [...invoiceFiles]
    const newPercentages = [...invPercentage]
    newArray.splice(index, 1)
    newPercentages.splice(index, 1)
    setInvoiceFiles(newArray)
    setInvPercentage(newPercentages)
  }

  const handleCertDelete = (name: string, index: number) => {
    const newArray = [...certificateFiles]
    const newPercentages = [...certPercentage]
    newArray.splice(index, 1)
    newPercentages.splice(index, 1)
    setCertificateFiles(newArray)
    setCertPercentage(newPercentages)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setStock({
      ...stock,
      [name]: value,
    })
  }

  const handleSwitchToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.target
    switch (name) {
      case 'omie':
        setUpdateInOmie(!updateInOmie)
        break
      case 'calcLength':
        if (calculateWeight) {
          setCalculateWeight(false)
        }
        setCalculateLength(!calculateLength)
        break
      case 'calcWeight':
        if (calculateLength) {
          setCalculateLength(false)
        }
        setCalculateWeight(!calculateWeight)
        break
      default:
        console.log('Caminho inesperado ao ativar um switch toggle')
        break
    }
  }

  const handleDropdownClick = (value: string, field: string) => {
    setStock({
      ...stock,
      [field]: value,
    })
    setActiveMenu(0)
  }

  const previousPage = () => {
    console.log('🔙 [THIRDPAGE] Voltando para segunda página');
    console.log('📋 [THIRDPAGE] Estado atual antes de voltar:', {
      code: stock.code,
      ncm: stock.ncm,
      trackingNumber: stock.trackingNumber,
      hasInvoiceFiles: invoiceFiles.length > 0,
      hasCertificateFiles: certificateFiles.length > 0
    });
    setModalSection('secondCustomAdd')
  }

  const handleSubmit = async () => {
    console.log('🚀 [FRONTEND] Iniciando handleSubmit na ThirdPage');

    const currentToken = token || localStorage.getItem('token')
    console.log('🔑 [FRONTEND] Token status:', {
      hasTokenFromContext: !!token,
      hasTokenFromStorage: !!localStorage.getItem('token'),
      tokenPreview: currentToken ? `${currentToken.substring(0, 30)}...` : 'sem token'
    });

    if (!currentToken) {
      console.error('❌ [FRONTEND] Nenhum token encontrado');
      setWarningMessage('Sessão expirada. Faça login novamente.')
      setTimeout(() => {
        localStorage.removeItem('token')
        window.location.href = '/'
      }, 2000)
      return
    }

    const validation = validateToken(currentToken)
    console.log('✅ [FRONTEND] Validação do token:', validation);

    if (validation.isExpired) {
      console.error('❌ [FRONTEND] Token expirado:', validation.message);
      setWarningMessage(`${validation.message}. Redirecionando para login...`)
      setTimeout(() => {
        localStorage.removeItem('token')
        window.location.href = '/'
      }, 2000)
      return
    }

    if (stock.code === '') {
      setWarningMessage(`O campo "Código" é obrigatório!`)
      return
    }
    if (updateInOmie) {
      if (stock.ncm === '') {
        setWarningMessage(
          `O campo "NCM" é obrigatório para atualização na Omie!`,
        )
        return
      }
      if (stock.trackingNumber === '') {
        setWarningMessage(
          `O campo "Número de Rastreamento" é obrigatório para atualização na Omie!`,
        )
        return
      }
    }
    if (calculateLength && stock.lengthInMm !== '') {
      setWarningMessage(
        `O comprimento já está preenchido, ele não pode ser calculado!`,
      )
      return
    }
    if (calculateWeight && stock.totalWeight !== '') {
      setWarningMessage(
        `O peso já está preenchido, ele não pode ser calculado!`,
      )
      return
    }

    console.log('📦 [FRONTEND] Preparando FormData:', {
      itIsUpdate,
      stockId: stock.id,
      code: stock.code,
      hasInvoice: stock.invoice?.length > 0,
      hasCertificates: stock.certificates?.length > 0,
      stockFields: Object.keys(stock).filter(key => key !== 'invoice' && key !== 'certificates'),
      invoiceCount: stock.invoice?.length || 0,
      certificatesCount: stock.certificates?.length || 0
    })

    console.log('🔍 [FRONTEND-DEBUG] Análise completa do objeto stock:', {
      totalFields: Object.keys(stock).length,
      isUpdate: itIsUpdate,
      stockId: stock.id
    });

    const stockFields = Object.keys(stock).filter(key => key !== 'invoice' && key !== 'certificates');
    const filledFields = stockFields.filter(key => {
      const value = stock[key as keyof StockInterface];
      return value !== undefined && value !== null && value !== '' && (typeof value === 'number' ? value !== 0 : true);
    });
    const emptyFields = stockFields.filter(key => {
      const value = stock[key as keyof StockInterface];
      return value === undefined || value === null || value === '' || (typeof value === 'number' && value === 0);
    });

    console.log('📊 [FRONTEND-DEBUG] Campos preenchidos:', {
      count: filledFields.length,
      fields: filledFields
    });

    console.log('🚿 [FRONTEND-DEBUG] Campos vazios:', {
      count: emptyFields.length,
      fields: emptyFields
    });

    const updateSpecificFields = ['id', 'createdAt', 'updatedAt', 'createdBy', 'tenantId'];
    const presentUpdateFields = stockFields.filter(field => updateSpecificFields.includes(field));

    if (itIsUpdate) {
      console.log('🔄 [FRONTEND-DEBUG] MODO UPDATE - Comparando campos extras:');

      const emptyStock = {
        material: '',
        format: '',
        family: '',
        density: '',
      };

      const extraFields = stockFields.filter(field => !Object.prototype.hasOwnProperty.call(emptyStock, field));
      console.log('📍 [FRONTEND-DEBUG] Campos extras no UPDATE (não presentes no CREATE):');
      console.log('📍 [FRONTEND-DEBUG] Total de campos extras:', extraFields.length);
      console.log('📍 [FRONTEND-DEBUG] Campos extras:', extraFields);

      const extraFieldsValues = extraFields.reduce((acc, field) => {
        acc[field] = stock[field as keyof StockInterface];
        return acc;
      }, {} as any);

      console.log('📍 [FRONTEND-DEBUG] Valores dos campos extras:', extraFieldsValues);
    } else {
      console.log('➕ [FRONTEND-DEBUG] MODO CREATE - Objeto stock mais limpo');
    }

  setIsSaving(true)
    const formData = new FormData()

    console.log('🔧 [FRONTEND-DEBUG] Iniciando criação do FormData...');
    let addedFieldsCount = 0;
    const addedFields: string[] = [];
    const skippedFields: string[] = [];

    for (const key in stock) {
      if (
        Object.prototype.hasOwnProperty.call(stock, key) &&
        key !== 'invoice' &&
        key !== 'certificates'
      ) {
        const value = stock[key as keyof StockInterface] as string
        formData.append(key, value)
        addedFieldsCount++;
        addedFields.push(key);

        if (addedFieldsCount <= 10) {
          console.log(`🔢 [FRONTEND-DEBUG] Campo ${addedFieldsCount}: ${key} = ${typeof value === 'string' ? value.substring(0, 30) : value}...`);
        }
      } else {
        skippedFields.push(key);
      }
    }

    console.log('📊 [FRONTEND-DEBUG] FormData - Resumo da criação:', {
      totalFieldsAdded: addedFieldsCount,
      addedFields: addedFields.length > 20 ? addedFields.slice(0, 20).concat(['...']) : addedFields,
      skippedFields,
      isUpdate: itIsUpdate
    });

    stock.invoice?.forEach((file: any, index: number) => {
      formData.append('invoice', file)
    })
    stock.certificates?.forEach((file: any, index: number) => {
      formData.append('certificates', file)
    })

    if (itIsUpdate) stock.availableBalance = '0'

    const currentTokenFinal = token || localStorage.getItem('token')
    console.log('🚀 [FRONTEND] Fazendo chamada para ApiService:', {
      method: itIsUpdate ? 'UPDATE' : 'CREATE',
      endpoint: itIsUpdate ? `/backend/stock/${stock.id}` : '/backend/stock',
      hasFormData: true,
      formDataSize: `${(new Blob([...formData.values()]).size / 1024).toFixed(2)}KB`,
      hasToken: !!currentTokenFinal
    });

    try {
      console.log('[THIRDPAGE] Checando existência de code antes de criar...');
      const codeCheckResp = await ApiService.post('/backend/stock/findProductByCode', { code: stock.code });
      const codeData = codeCheckResp?.data;
      let shouldProceedDirectly = true;
      let existingStockData: any = null;

      if (codeData && codeData.id) {
        console.log('[THIRDPAGE] Code encontrado, consultando stock por codeId:', codeData.id);
        const stockResp = await ApiService.get(`/backend/stock/findProductById/${codeData.id}`);
        existingStockData = stockResp?.data;
        if (existingStockData) {
          console.log('[THIRDPAGE] Existe estoque para este code. Abrindo modal de confirmação antes de sobrescrever.');
          shouldProceedDirectly = false;
          setExistingProduct(existingStockData);
          setShowConfirmModal(true);
        }
      }

      if (!shouldProceedDirectly) {
        setIsSaving(false);
        return;
      }

      let response;

      const headers: any = {
        'Update-in-omie': String(updateInOmie),
        'Weight-calculate': String(calculateWeight),
        'Length-calculate': String(calculateLength),
      }

      console.debug('[THIRDPAGE] Enviando request de Create/Update stock com headers ->', {
        endpoint: itIsUpdate ? `/backend/stock/${stock.id}` : '/backend/stock',
        updateInOmie,
        calculateWeight,
        calculateLength,
        headers,
      })

      if (itIsUpdate) {
        console.log('🔄 [FRONTEND] Chamando ApiService.put (update) com header Update-in-omie');
        response = await ApiService.put(`/backend/stock/${stock.id}`, formData, { headers })
      } else {
        console.log('➕ [FRONTEND] Chamando ApiService.post (create) com header Update-in-omie');
        response = await ApiService.post('/backend/stock', formData, { headers })
      }

      console.log('✅ [FRONTEND] Resposta recebida com sucesso:', {
        status: response?.status,
        hasData: !!response?.data,
        responseType: typeof response?.data
      });

      setRefresh((prev) => !prev)

      setIsClosing(true)
      setTimeout(() => {
        setModalActive(false)
      }, 1000)
    } catch (err: any) {
      console.error('❌ [FRONTEND] Erro na requisição:', {
        status: err.response?.status,
        statusText: err.response?.statusText,
        message: err.message,
        responseData: err.response?.data,
        config: {
          url: err.config?.url,
          method: err.config?.method,
          hasAuth: !!err.config?.headers?.Authorization,
          headers: Object.keys(err.config?.headers || {})
        }
      });

      if (err.response?.status === 401) {
        console.error('🚫 [FRONTEND] Erro 401 - Sessão expirada');
        setWarningMessage('Sessão expirada durante o salvamento. Redirecionando para login...')
        setTimeout(() => {
          localStorage.removeItem('token')
          window.location.href = '/'
        }, 2000)
      } else if (err.response?.status === 403) {
        console.error('🚫 [FRONTEND] Erro 403 - Acesso negado');
        setWarningMessage('Acesso negado. Verifique suas permissões.')
      } else if (err.response?.status === 422) {
        console.error('⚠️ [FRONTEND] Erro 422 - Validação');
        setWarningMessage(`Erro de validação: ${err.response?.data?.message || 'Dados inválidos'}`)
      } else if (err.response?.data?.message) {
        console.error('⚠️ [FRONTEND] Erro com mensagem do servidor:', err.response.data.message);
        setWarningMessage(err.response.data.message)
      } else {
        console.error('❌ [FRONTEND] Erro genérico:', err);
        setWarningMessage('Ocorreu um erro ao salvar o estoque. Tente novamente.')
      }
    } finally {
      setIsSaving(false)
    }
  }

  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [existingProduct, setExistingProduct] = useState<any | null>(null)

  const confirmUpdate = async () => {
    setShowConfirmModal(false)
    setIsSaving(true)
    try {
      const formData = new FormData()
      for (const key in stock) {
        if (
          Object.prototype.hasOwnProperty.call(stock, key) &&
          key !== 'invoice' &&
          key !== 'certificates'
        ) {
          const value = stock[key as keyof StockInterface] as string
          formData.append(key, value)
        }
      }
      stock.invoice?.forEach((file: any) => formData.append('invoice', file))
      stock.certificates?.forEach((file: any) => formData.append('certificates', file))

      const headers: any = {
        'Update-in-omie': String(updateInOmie),
        'Weight-calculate': String(calculateWeight),
        'Length-calculate': String(calculateLength),
      }

      const response = await ApiService.post('/backend/stock', formData, { headers })
      setRefresh((prev) => !prev)
      setIsClosing(true)
      setTimeout(() => setModalActive(false), 1000)
    } catch (err: any) {
      console.error('[THIRDPAGE][confirmUpdate] Erro ao confirmar update:', err)
      setWarningMessage('Falha ao atualizar o estoque. Verifique o console para detalhes.')
    } finally {
      setIsSaving(false)
    }
  }

  const cancelUpdate = () => {
    setShowConfirmModal(false)
    setExistingProduct(null)
    setWarningMessage('Ação cancelada pelo usuário.')
  }

  const ProgressBar: React.FC<ProgressBar> = (props) => {
    const fillerStyles = {
      width: `${props.completion}%`,
    }

    return (
      <ProgressContainer>
        <ProgressFill style={fillerStyles} />
      </ProgressContainer>
    )
  }

  const WarningBox = () => {
    return (
      <WarningDiv>
        <WarningText>{warningMessage}</WarningText>
      </WarningDiv>
    )
  }

  const fieldsArray: string[][] = [
    ['code', 'ncm'],
    ['trackingNumber', 'purchaseOrder'],
  ]

  const requiredFields = ['ncm', 'trackingNumber']
  const switches: string[] = ['omie']
  const switchesText: string[] = [
    'Atualizar produtos na Omie',
  ]
  const switchValues: boolean[] = [
    updateInOmie,
    calculateLength,
    calculateWeight,
  ]

  return (
    <>
      {isClosing && <LoadingComponent />}
      <Container>
        <HeaderDiv>
          <HeaderText>
            {itIsUpdate ? 'Editar Estoque' : 'Adicionar Estoque'}
          </HeaderText>
          <CloseDiv onClick={() => setModalActive(false)}>
            <CloseImg src={cross} alt='Close tab' />
          </CloseDiv>
        </HeaderDiv>
        <ProgressBarDiv>
          <ProgressBarCircle className='active' />
          <ProgressBarLine className='active' />
          <ProgressBarCircle className='active' />
          <ProgressBarLine className='active' />
          <ProgressBarCircle className='active' />
        </ProgressBarDiv>
        {fieldsArray.map((inputRow, rowIndex) => (
          <InputRowDiv key={rowIndex}>
            {inputRow.map((stockField: string, colIndex) => {
              const isRequired =
                requiredFields.includes(stockField) || stockField === 'code'
              return (
                <InputDiv key={colIndex}>
                  {activeMenu == rowIndex * 3 + colIndex + 1 ? (
                    <StockDropdown
                      text={stock[stockField as keyof StockInterface]}
                      field={stockField}
                      onChange={(value) => {
                        handleDropdownClick(value, stockField)
                      }}
                    />
                  ) : null}
                  <InputLabel htmlFor={stockField}>
                    {fieldsToHeaders[stockField as keyof FieldsToHeaders]}
                    {(stockField === 'code' ||
                      (updateInOmie && isRequired)) && (
                        <Info
                          size={15}
                          style={{ marginLeft: 5 }}
                          color={
                            !stock[stockField as keyof StockInterface]
                              ? 'red'
                              : 'gray'
                          }
                        />
                      )}
                  </InputLabel>
                  <Input
                    placeholder='Digite aqui'
                    name={stockField}
                    value={stock[stockField as keyof StockInterface] || ''}
                    onFocus={() => setActiveMenu(rowIndex * 3 + colIndex + 1)}
                    onBlur={() => setActiveMenu(0)}
                    onChange={handleChange}
                    autoComplete='off'
                    className={
                      stockField === 'code' &&
                        warningMessage === '!O campo "código" é obrigatório'
                        ? 'redBorder'
                        : ''
                    }
                  />
                </InputDiv>
              )
            })}
          </InputRowDiv>
        ))}

        <SwitchesDiv>
          {switches.map((field, index) => (
            <SwitchDiv key={field}>
              <SwitchLabel htmlFor={field}>{switchesText[index]}</SwitchLabel>
              <SwitchBox>
                <SwitchInput
                  type='checkbox'
                  name={field}
                  checked={switchValues[index]}
                  onChange={handleSwitchToggle}
                />
                <SwitchSlider className='slider'></SwitchSlider>
              </SwitchBox>
            </SwitchDiv>
          ))}
        </SwitchesDiv>
        <FilesDiv>
          <FileBlockDiv>
            <FileHeaderText>Nota fiscal</FileHeaderText>
            {invoiceFiles.length === 0 ? (
              <FileInputDiv>
                <FileInputLabel htmlFor='invoice'>
                  Procurar
                  <FileInput
                    type='file'
                    id='invoice'
                    name='invoice'
                    multiple
                    onChange={handleUploadInvoice}
                  />
                </FileInputLabel>
                <FileFirstText>ou arraste um arquivo até aqui</FileFirstText>
                <FileSecondText>
                  Apenas arquivos .pdf de no máximo 10mb
                </FileSecondText>
              </FileInputDiv>
            ) : (
              <span>
                <FilesInfoDiv>
                  {invoiceFiles.map((file, index) => (
                    <FileInfoDiv key={file.name}>
                      <FileInfoImg src={fileIcon} alt='File icon' />
                      <FileMiddleDiv>
                        <FileUpperMiddleDiv>
                          <FileName>{file.name}</FileName>
                          <FilePercentage>
                            {invPercentage[index]}%
                          </FilePercentage>
                        </FileUpperMiddleDiv>
                        <ProgressBar completion={invPercentage[index]} />
                      </FileMiddleDiv>
                      <FileInfoCancelImg
                        src={cancelIcon}
                        alt='File icon'
                        onClick={() => handleInvDelete(file.name, index)}
                      />
                    </FileInfoDiv>
                  ))}
                </FilesInfoDiv>
                <FileInputLabel htmlFor='invoice' className='down'>
                  Procurar
                  <FileInput
                    type='file'
                    id='invoice'
                    name='invoice'
                    multiple
                    onChange={handleUploadInvoice}
                  />
                </FileInputLabel>
              </span>
            )}
          </FileBlockDiv>
          <FileBlockDiv>
            <FileHeaderText>Certificados</FileHeaderText>
            {certificateFiles.length === 0 ? (
              <FileInputDiv>
                <FileInputLabel htmlFor='certificates'>
                  Procurar
                  <FileInput
                    type='file'
                    id='certificates'
                    name='certificates'
                    multiple
                    onChange={handleUploadCertificates}
                  />
                </FileInputLabel>
                <FileFirstText>ou arraste um arquivo até aqui</FileFirstText>
                <FileSecondText>
                  Apenas arquivos .pdf de no máximo 10mb
                </FileSecondText>
              </FileInputDiv>
            ) : (
              <span>
                <FilesInfoDiv>
                  {certificateFiles.map((file, index) => (
                    <FileInfoDiv key={file.name}>
                      <FileInfoImg src={fileIcon} alt='File icon' />
                      <FileMiddleDiv>
                        <FileUpperMiddleDiv>
                          <FileName>{file.name}</FileName>
                          <FilePercentage>
                            {certPercentage[index]}%
                          </FilePercentage>
                        </FileUpperMiddleDiv>
                        <ProgressBar completion={certPercentage[index]} />
                      </FileMiddleDiv>
                      <FileInfoCancelImg
                        src={cancelIcon}
                        alt='File icon'
                        onClick={() => handleCertDelete(file.name, index)}
                      />
                    </FileInfoDiv>
                  ))}
                </FilesInfoDiv>
                <FileInputLabel htmlFor='certificate' className='down'>
                  Procurar
                  <FileInput
                    type='file'
                    id='certificate'
                    name='certificate'
                    multiple
                    onChange={handleUploadCertificates}
                  />
                </FileInputLabel>
              </span>
            )}
          </FileBlockDiv>
        </FilesDiv>
        <ButtonsDiv>
          <WarningBox />
          <PreviousButtonDiv onClick={previousPage}>
            <PreviousButtonImage src={arrowLeft} alt='Right arrow icon' />
            <PreviousButtonText>Voltar</PreviousButtonText>
          </PreviousButtonDiv>
          <NextButtonDiv
            onClick={isSaving ? undefined : () => {
              handleSubmit()
            }}
            className={warningMessage !== '' || isSaving ? 'disabled' : ''}
          >
            {isSaving ? (
              <LoadingButtonContent />
            ) : (
              <>
                <NextButtonImage src={diskIcon} alt='Save icon' />
                <NextButtonText>Salvar</NextButtonText>
              </>
            )}
          </NextButtonDiv>
        </ButtonsDiv>
        {showConfirmModal && existingProduct && (
          <ConfirmationModal
            isOpen={showConfirmModal}
            title={'Código já existe — confirmar atualização'}
            message={(() => {
              const fieldsToCompare = [
                'code',
                'material',
                'quantity',
                'totalWeight',
                'lengthInMm',
                'dimension1',
                'dimension2',
                'costPerKg',
                'costPerMm',
                'totalCost',
                'format',
                'ncm',
                'trackingNumber',
                'description',
                'family',
                'measurementUnit',
              ] as string[]

              const getExisting = (f: string) => {
                if (!existingProduct) return ''
                if (f === 'code') return existingProduct?.code || existingProduct?.Code || (existingProduct?.code?.code) || ''
                if (f === 'material') return existingProduct?.material?.name || existingProduct?.material || existingProduct?.Material || ''
                if (f === 'format') return existingProduct?.format?.type || existingProduct?.format || ''
                if (f === 'ncm') return existingProduct?.ncm?.ncm || existingProduct?.ncm || ''
                if (f === 'trackingNumber') return existingProduct?.trackingNumber || existingProduct?.tracking_number || ''
                if (f === 'description') return existingProduct?.description || ''
                if (f === 'family') return existingProduct?.family || ''
                if (f === 'measurementUnit') return existingProduct?.measurementUnit || existingProduct?.measurement_unit || ''
                return existingProduct?.[f] ?? ''
              }

              const numericFields = ['quantity','totalWeight','lengthInMm','dimension1','dimension2','costPerKg','costPerMm','totalCost','runNumber']

              const rows = fieldsToCompare
                .map((f) => {
                  const existingVal = getExisting(f)
                  const newValRaw = (stock as any)[f]
                  const newValStr = newValRaw === undefined || newValRaw === null ? '' : String(newValRaw)

                  let willChange = false
                  if (newValStr === '') {
                    willChange = false
                  } else if (numericFields.includes(f)) {
                    const eNum = Number(existingVal)
                    const nNum = Number(newValStr)
                    willChange = !(Number.isNaN(eNum) && Number.isNaN(nNum)) && eNum !== nNum
                  } else {
                    willChange = String(existingVal).trim() !== newValStr.trim()
                  }

                  if (!willChange) return null

                  const displayExisting = String(existingVal) === '' ? '-' : String(existingVal)
                  const displayNew = newValStr === '' ? displayExisting : newValStr

                  return (
                    <div key={f} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', background: '#fff8dc', borderRadius: 6, marginBottom: 6, alignItems: 'center' }}>
                      <div style={{ flex: 1, fontWeight: 700 }}>{(fieldsToHeaders as any)[f] || f}</div>
                      <div style={{ flex: 1, textAlign: 'left', color: '#666' }}>{displayExisting}</div>
                      <div style={{ flex: 1, textAlign: 'left', color: '#000', fontWeight: 600 }}>{displayNew}</div>
                    </div>
                  )
                })
                .filter(Boolean)

              return (
                <div style={{ maxHeight: '70vh', overflowY: 'auto', paddingRight: 8 }}>
                  <div style={{ marginBottom: 8 }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, fontWeight: 700 }}>
                      <div>Campo</div>
                      <div>Atuais</div>
                      <div>Enviados</div>
                    </div>
                  </div>
                  <div style={{ display: 'grid', gap: 8 }}>
                    {rows.length > 0 ? rows : <div>Nenhum campo será alterado com os valores fornecidos.</div>}
                  </div>
                </div>
              )
            })()}
            actions={[
              { label: 'Cancelar', onClick: cancelUpdate, variant: 'outline' },
              { label: 'Confirmar atualização', onClick: confirmUpdate, variant: 'primary' },
            ]}
          />
        )}
      </Container>
    </>
  )
}

export default ThirdCustomAddPage
